export const REGISTER_NOTE_MESSAGE = "백데이터 등록";
